export const linkBaseUrl = process.env.REACT_APP_REDIRECT_URL
export const countries = {
  //* Africa
  africa: ['South Africa', 'Kenya', 'Tanzania', 'Zanzibar', 'Namibia'],
  africaHolidaysLinks: [
    `${linkBaseUrl}africa-holidays/south-africa/tours`,
    `${linkBaseUrl}africa-holidays/kenya/safari`,
    `${linkBaseUrl}africa-holidays/tanzania/safari`,
    `${linkBaseUrl}africa-holidays/zanzibar`,
    `${linkBaseUrl}africa-holidays/namibia`,
  ],

  //* Australia
  australia: ['South Pacific'],
  australiaHolidaysLinks: [`${linkBaseUrl}south-pacific-holidays`],

  //* Caribbean
  caribbean: [
    'Anguilla',
    'Dominican Republic',
    'Antigua',
    'Grenada',
    'Aruba',
    'Grenadines',
    'Bahamas',
    'Jamaica',
    'Barbados',
    'Mexico',
    'Bermuda',
    'St Kitts and Nevis',
    'British Virgin Islands',
    'St Lucia',
    'Cayman Islands',
    'Tobago',
  ],
  caribbeanHolidaysLinks: [
    `${linkBaseUrl}caribbean-holidays/anguilla`,
    `${linkBaseUrl}caribbean-holidays/dominican-republic`,
    `${linkBaseUrl}caribbean-holidays/antigua/hotels`,
    `${linkBaseUrl}caribbean-holidays/grenada`,
    `${linkBaseUrl}caribbean-holidays/aruba`,
    `${linkBaseUrl}caribbean-holidays/grenadines`,
    `${linkBaseUrl}caribbean-holidays/bahamas`,
    `${linkBaseUrl}caribbean-holidays/jamaica`,
    `${linkBaseUrl}caribbean-holidays/barbados/hotels`,
    `${linkBaseUrl}caribbean-holidays/mexico`,
    `${linkBaseUrl}caribbean-holidays/bermuda`,
    `${linkBaseUrl}caribbean-holidays/st-kitts-and-nevis`,
    `${linkBaseUrl}caribbean-holidays/british-virgin-islands`,
    `${linkBaseUrl}caribbean-holidays/st-lucia`,
    `${linkBaseUrl}caribbean-holidays/cayman-islands`,
    `${linkBaseUrl}caribbean-holidays/tobago`,
  ],

  //* Middle Eash
  middleEast: ['Abu Dhabi', 'Dubai and the Emirates', 'Oman', 'Qatar'],
  middleEastHolidaysLinks: [
    `${linkBaseUrl}middle-east-holidays/abu-dhabi`,
    `${linkBaseUrl}middle-east-holidays/dubai-and-the-emirates`,
    `${linkBaseUrl}middle-east-holidays/oman`,
    `${linkBaseUrl}middle-east-holidays/qatar`,
  ],

  //* Europe
  europe: [
    'Cyprus',
    'Croatia',
    'Greece',
    'Italy',
    'Madeira',
    'Malta',
    'Morocco',
    'Montenegro',
    'Portugal',
    'Spain',
    'Turkey',
  ],
  europeHolidaysLinks: [
    `${linkBaseUrl}europe-holidays/cyprus`,
    `${linkBaseUrl}europe-holidays/croatia`,
    `${linkBaseUrl}europe-holidays/greece`,
    `${linkBaseUrl}europe-holidays/italy`,
    `${linkBaseUrl}europe-holidays/madeira`,
    `${linkBaseUrl}europe-holidays/malta`,
    `${linkBaseUrl}europe-holidays/morocco`,
    `${linkBaseUrl}europe-holidays/montenegro`,
    `${linkBaseUrl}europe-holidays/portugal`,
    `${linkBaseUrl}europe-holidays/spain`,
    `${linkBaseUrl}europe-holidays/turkey`,
  ],

  //* Far Eash
  farEast: [
    'Bali',
    'Cambodia',
    'China',
    'Hong Kong',
    'India',
    'Japan',
    'Malaysia',
    'Singapore',
    'Thailand',
    'Vietnam',
  ],
  farEastHolidaysLinks: [
    `${linkBaseUrl}far-east-holidays/bali`,
    `${linkBaseUrl}far-east-holidays/cambodia`,
    `${linkBaseUrl}far-east-holidays/china`,
    `${linkBaseUrl}far-east-holidays/hong-kong`,
    `${linkBaseUrl}far-east-holidays/india`,
    `${linkBaseUrl}far-east-holidays/japan`,
    `${linkBaseUrl}far-east-holidays/malaysia`,
    `${linkBaseUrl}far-east-holidays/dingapore`,
    `${linkBaseUrl}far-east-holidays/thailand`,
    `${linkBaseUrl}far-east-holidays/vietnam`,
  ],

  //* Indian Ocean
  indiaOcean: ['Maldives', 'Mauritius', 'Seychelles', 'Sri Lanka', 'Reunion'],
  indianOceanHolidaysLinks: [
    `${linkBaseUrl}indian-ocean-holidays/maldives/hotels`,
    `${linkBaseUrl}indian-ocean-holidays/mauritius`,
    `${linkBaseUrl}indian-ocean-holidays/seychelles`,
    `${linkBaseUrl}indian-ocean-holidays/sri-lanka`,
    `${linkBaseUrl}indian-ocean-holidays/reunion`,
  ],

  //* North America
  northAmerica: [],

  //* Polar
  polar: ['Antarctica', 'Arctic'],
  polarHolidaysLinks: [`${linkBaseUrl}polar-holidays/antarctica`, `${linkBaseUrl}polar-holidays/arctic`],

  //* South Central America
  southCentralAmerica: [
    'Argentina',
    'Brazil',
    'Chile',
    'Colombia',
    'Costa Rica',
    'Ecuador and Galapagos Islands',
    'Peru',
  ],
  southCentralAmericaHolidaysLinks: [
    `${linkBaseUrl}south-central-america-holidays/argentina`,
    `${linkBaseUrl}south-central-america-holidays/brazil`,
    `${linkBaseUrl}south-central-america-holidays/chile`,
    `${linkBaseUrl}south-central-america-holidays/colombia`,
    `${linkBaseUrl}south-central-america-holidays/costa-rica`,
    `${linkBaseUrl}south-central-america-holidays/ecuador-and-galapagos-islands`,
    `${linkBaseUrl}south-central-america-holidays/peru`,
  ],
};
